import { render } from "./ModelCreate.vue?vue&type=template&id=10c08b92"
import script from "./ModelCreate.vue?vue&type=script&lang=js"
export * from "./ModelCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__